import { render, staticRenderFns } from "./TransferedHeader.vue?vue&type=template&id=59f9dfc1"
import script from "./TransferedHeader.vue?vue&type=script&lang=js"
export * from "./TransferedHeader.vue?vue&type=script&lang=js"
import style0 from "./TransferedHeader.vue?vue&type=style&index=0&id=59f9dfc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports